// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
// ANTD
import Table from 'antd/lib/table';
// APOLLO
import questionnairesByClientIdQuery from 'ApolloClient/Queries/questionnairesByClientId';
import { graphql } from 'react-apollo';
// MODULES
import { MOBILE_COLUMNS, FULL_SCREEN_COLUMNS } from './columns';
import SectionHeader from 'components/text/SectionHeader';
import SectionRow from 'components/common/SectionRow';

export class ClientQuestionnaires extends React.Component {
  render() {
    const { windowWidth } = this.props;
    return (
      <SectionRow>
        <div>
          <SectionHeader>QUESTIONNAIRES</SectionHeader>
        </div>

        <Table
          loading={this.props.questionnairesByClientIdQuery.loading}
          rowKey={record => record._id}
          pagination={{
            defaultPageSize: 5,
          }}
          columns={windowWidth < 789 ? MOBILE_COLUMNS : FULL_SCREEN_COLUMNS}
          dataSource={this.props.questionnairesByClientIdQuery.questionnairesByClientId}
        />
      </SectionRow>
    );
  }
}

let options = props => ({
  variables: {
    _id: props.clientId,
  },
});

export default graphql(questionnairesByClientIdQuery, { name: 'questionnairesByClientIdQuery', options })(
  ClientQuestionnaires,
);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientQuestionnaires/index.js